import {Vue} from "ui.vue";
import 'citrus.vue.vue-form.fields';

import Confirmation from './confirmation.vue';

Vue.component('Confirmation', Confirmation);
